const mergeById = (shared, localized) =>
  localized.map((loc) => {
    const base = shared.find((s) => s.id === loc.id);
    return base ? { ...base, ...loc } : loc;
  });

const mergePersonal = (shared, localized) => ({
  ...shared,
  ...localized,
  socialLinks: localized.socialLinks.map((loc, i) => ({
    ...shared.socialLinks[i],
    ...loc,
  })),
});

export { mergeById, mergePersonal };
